import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Box, Typography, Paper } from "@mui/material";

const GameweekDroppableMatchZone = ({
  id,
  children,
  title,
  count,
  isOver: externalIsOver,
  emptyMessage = "Drop matches here",
  showCount = true,
}) => {
  const { isOver, setNodeRef } = useDroppable({
    id: id,
  });

  const isActive = externalIsOver !== undefined ? externalIsOver : isOver;

  return (
    <Paper
      ref={setNodeRef}
      variant="outlined"
      sx={{
        p: 2,
        minHeight: 200,
        backgroundColor: isActive ? "#f5f5f5" : "background.paper",
        border: isActive ? "1px dashed #666" : "1px solid #e0e0e0",
        borderRadius: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
          pb: 1,
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography variant="h6">{title}</Typography>
        {showCount && (
          <Typography variant="body2" color="text.secondary">
            {count} matches
          </Typography>
        )}
      </Box>

      <Box>
        {children}

        {(!children || (Array.isArray(children) && children.length === 0)) && (
          <Box
            sx={{
              py: 4,
              textAlign: "center",
              color: "text.secondary",
              border: "1px dashed #e0e0e0",
              borderRadius: 1,
              backgroundColor: "background.paper",
            }}
          >
            <Typography variant="body1" color="text.secondary">
              {isActive ? "Drop here" : emptyMessage}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default GameweekDroppableMatchZone;
